export default "__VITE_ASSET__40e3a51f__"